import { getRGBAvalues } from '@anm/helpers/color/hex2rgba';

var luminanace = function luminanace(r, g, b) {
  var a = [r, g, b].map(function (v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

var getContrast = function getContrast(color1, color2) {
  if (!color1 || !color2) return 0;
  var rgb1 = getRGBAvalues(color1);
  var rgb2 = getRGBAvalues(color2);
  var lum1 = luminanace(rgb1[0], rgb1[1], rgb1[2]);
  var lum2 = luminanace(rgb2[0], rgb2[1], rgb2[2]);
  var brightest = Math.max(lum1, lum2);
  var darkest = Math.min(lum1, lum2);
  return (brightest + 0.05) / (darkest + 0.05);
};

export default getContrast;